import { ChannelTypes } from 'conversations-internal-schema/constants/ChannelTypes';
import { CALLING_GENERIC_CHANNEL_ID, EMAIL_GENERIC_CHANNEL_ID, FORMS_GENERIC_CHANNEL_ID, LIVE_CHAT_GENERIC_CHANNEL_ID } from 'conversations-message-history/common-message-format/constants/genericChannelIds';
import { BOT } from 'conversations-internal-schema/routing-rules/constants/RoutingTypes';
export const CHANNEL_MIGRATION_STATES = {
  COMPLETE: 'COMPLETE',
  FAILED: 'FAILED',
  SCHEDULED: 'SCHEDULED',
  STARTED: 'STARTED'
};
export const MIGRATABLE_CHANNEL_TYPES = [BOT, ChannelTypes.CHAT, ChannelTypes.EMAIL, ChannelTypes.FORMS, ChannelTypes.CALLING];
export const MIGRATABLE_CHANNEL_IDS = {
  LIVE_CHAT: LIVE_CHAT_GENERIC_CHANNEL_ID,
  EMAIL: EMAIL_GENERIC_CHANNEL_ID,
  FORMS: FORMS_GENERIC_CHANNEL_ID,
  CALLING: CALLING_GENERIC_CHANNEL_ID
};
export const INBOX_TO_HELPDESK = 'INBOX_TO_HELPDESK';
export const HELPDESK_TO_INBOX = 'HELPDESK_TO_INBOX';
export const HelpDeskToInboxWizardSteps = {
  CHOOSE_CHANNEL_STEP: 0,
  CHOOSE_CHATFLOW_STEP: 1,
  MIGRATION_STATUS_STEP: 2
};